import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DartboardTableService {

  public allJobs$: BehaviorSubject<any[]>;
  public displayedJobs$: BehaviorSubject<any[]>;
  public dateRangeJobs$: BehaviorSubject<any[]>;
  public closeRateJobs$: BehaviorSubject<any[]>;
  public soldJobs$: BehaviorSubject<any[]>;
  public soldCount$: BehaviorSubject<number>;
  public lostCount$: BehaviorSubject<number>;
  public pendingCount$: BehaviorSubject<number>;
  public currentFilters$: BehaviorSubject<{
    status: string;
    consultant: string;
    leadType: string;
    date: string;
    customer: string;
  }>;

  constructor() {
    this.allJobs$ = new BehaviorSubject([]);
    this.displayedJobs$ = new BehaviorSubject([]);
    this.dateRangeJobs$ = new BehaviorSubject([]);
    this.closeRateJobs$ = new BehaviorSubject([]);
    this.soldJobs$ = new BehaviorSubject([]);
    this.soldCount$ = new BehaviorSubject(0);
    this.lostCount$ = new BehaviorSubject(0);
    this.pendingCount$ = new BehaviorSubject(0);
    this.currentFilters$ = new BehaviorSubject({
      status: '',
      consultant: '',
      leadType: '',
      date: '',
      customer: ''
    });

    // Subscribe to changes in dateRangeJobs$ and currentFilters$ to update closeRateJobs$
    combineLatest([this.dateRangeJobs$, this.currentFilters$]).pipe(
      map(([jobs, filters]) => {
        return filters.consultant ? jobs.filter(job => job.meta.createdBy === filters.consultant) : jobs;
      })
    ).subscribe(filteredJobs => {
      this.closeRateJobs$.next(filteredJobs);
    });
  }

}